import { styled } from '@mui/material/styles'

const isCustomColor = (color) =>
  typeof color === 'string' &&
  (color.startsWith('#') || color.startsWith('rgb') || color.startsWith('hsl'))

const hexToRgba = (hex, alpha = 0.12) => {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex)
  if (!result) return hex
  const r = parseInt(result[1], 16)
  const g = parseInt(result[2], 16)
  const b = parseInt(result[3], 16)
  return `rgba(${r}, ${g}, ${b}, ${alpha})`
}

const SeverityPillRoot = styled('span')(({ theme, ownerState }) => {
  let backgroundColor
  let color

  if (isCustomColor(ownerState.color)) {
    if (ownerState.color.startsWith('#')) {
      backgroundColor = hexToRgba(ownerState.color)
    } else if (ownerState.color.startsWith('rgba')) {
      backgroundColor = ownerState.color.replace(/,\s*[\d.]+\)$/, ', 0.12)')
    } else if (ownerState.color.startsWith('rgb')) {
      backgroundColor = ownerState.color.replace('rgb', 'rgba').replace(/\)$/, ', 0.12)')
    } else {
      backgroundColor = ownerState.color
    }
    color = ownerState.color
  } else {
    backgroundColor = theme.palette[ownerState.color]?.alpha12 ?? theme.palette.primary.alpha12
    color =
      theme.palette.mode === 'dark'
        ? theme.palette[ownerState.color]?.main ?? theme.palette.primary.main
        : theme.palette[ownerState.color]?.dark ?? theme.palette.primary.dark
  }

  return {
    alignItems: 'center',
    backgroundColor,
    borderRadius: 12,
    color,
    display: 'inline-flex',
    flexGrow: 0,
    flexShrink: 0,
    fontFamily: theme.typography.fontFamily,
    fontSize: theme.typography.pxToRem(12),
    lineHeight: 2,
    fontWeight: 600,
    justifyContent: 'center',
    letterSpacing: 0.5,
    minWidth: 20,
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
    textTransform: 'uppercase',
    whiteSpace: 'nowrap',
  }
})


export const Tag = (props) => {
  const { color = 'primary', children, ...other } = props

  const ownerState = { color }

  return (
    <SeverityPillRoot
      ownerState={ownerState}
      {...other}>
      {children}
    </SeverityPillRoot>
  )
}

